<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button mat-fab 
            color="accent" 
            (click)="executeToTop()"><i class="fa fa-chevron-up"></i>
    </button>
</div>